import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';
import type { NewsletterArchiveItem } from '@shared/types';

export function useNewsletterArchive() {
  return useQuery({
    queryKey: ['newsletter', 'archive'],
    queryFn: async () =>
      (await api.get<{ data: NewsletterArchiveItem[] }>('/newsletter')).data,
  });
}
